import {
  Box,
  Divider,
  Paper,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { FreeShippingMetadata } from '../../../interfaces/Offer/Metadata/FreeShipping';
import { sharedStyles } from '../../../utils/Style';
import NumberInput from '../../../components/NumberInput/NumberInput';
import { CitiesDropdown } from '../../../components/Dropdowns/CitiesDropdown';

type FreeShippingFormProps = {
  value: FreeShippingMetadata;
  onChange: (value: FreeShippingMetadata) => void;
  disabled?: boolean;
  minWidth: number;
  maxWidth: number;
};

export const FreeShippingForm = (props: FreeShippingFormProps) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 3,
        flexGrow: 1,
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
      }}
    >
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Kullanım Koşulları
      </Typography>
      <Divider />

      <NumberInput
        label='Minimum Sipariş Tutarı'
        disabled={props.disabled}
        value={props.value.spendLimit}
        onChange={(newValue) =>
          props.onChange({ ...props.value, spendLimit: newValue })
        }
        acceptFloat
        endAdornment={<Typography>₺</Typography>}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {props.value.applicableCities ? (
          <CitiesDropdown
            label='Seçili Şehirler'
            disabled={props.disabled}
            value={props.value.applicableCities}
            onChange={(newCities) =>
              props.onChange({ ...props.value, applicableCities: newCities })
            }
          />
        ) : (
          <TextField
            label='Seçili Şehirler'
            size='small'
            value='Tüm şehirler'
            disabled
            fullWidth
          />
        )}

        <Switch
          disabled={props.disabled}
          checked={!!props.value.applicableCities}
          onChange={() =>
            props.onChange({
              ...props.value,
              applicableCities: props.value.applicableCities ? undefined : [],
            })
          }
        />
      </Box>
    </Paper>
  );
};
